const eventBus = new Vue();
export default eventBus;